import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import commonEN from './locales/en/common.json';
import loginEN from './locales/en/login.json';
import dashboardEN from './locales/en/dashboard.json';
import invoicesEN from './locales/en/invoices.json';
import peopleEN from './locales/en/people.json';
import onboardingEN from './locales/en/onboarding.json';
import slackEN from './locales/en/slack.json';
import adminEN from './locales/en/admin.json';
import enumsEN from './locales/en/enums.json';
import vacationsEN from './locales/en/vacations.json';
import performanceReviewEN from './locales/en/performanceReview.json';

// Import Spanish translations
import commonES from './locales/es/common.json';
import loginES from './locales/es/login.json';
import dashboardES from './locales/es/dashboard.json';
import invoicesES from './locales/es/invoices.json';
import peopleES from './locales/es/people.json';
import onboardingES from './locales/es/onboarding.json';
import slackES from './locales/es/slack.json';
import adminES from './locales/es/admin.json';
import enumsES from './locales/es/enums.json';
import vacationsES from './locales/es/vacations.json';
import performanceReviewES from './locales/es/performanceReview.json';

// Import Portuguese (Brazilian) translations
import commonPT from './locales/pt/common.json';
import loginPT from './locales/pt/login.json';
import dashboardPT from './locales/pt/dashboard.json';
import invoicesPT from './locales/pt/invoices.json';
import peoplePT from './locales/pt/people.json';
import onboardingPT from './locales/pt/onboarding.json';
import slackPT from './locales/pt/slack.json';
import adminPT from './locales/pt/admin.json';
import enumsPT from './locales/pt/enums.json';
import vacationsPT from './locales/pt/vacations.json';
import performanceReviewPT from './locales/pt/performanceReview.json';

// Resources object containing all translations
const resources = {
  en: {
    common: commonEN,
    login: loginEN,
    dashboard: dashboardEN,
    invoices: invoicesEN,
    people: peopleEN,
    onboarding: onboardingEN,
    slack: slackEN,
    admin: adminEN,
    enums: enumsEN,
    vacations: vacationsEN,
    performanceReview: performanceReviewEN,
  },
  es: {
    common: commonES,
    login: loginES,
    dashboard: dashboardES,
    invoices: invoicesES,
    people: peopleES,
    onboarding: onboardingES,
    slack: slackES,
    admin: adminES,
    enums: enumsES,
    vacations: vacationsES,
    performanceReview: performanceReviewES,
  },
  pt: {
    common: commonPT,
    login: loginPT,
    dashboard: dashboardPT,
    invoices: invoicesPT,
    people: peoplePT,
    onboarding: onboardingPT,
    slack: slackPT,
    admin: adminPT,
    enums: enumsPT,
    vacations: vacationsPT,
    performanceReview: performanceReviewPT,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'login', 'dashboard', 'invoices', 'people', 'onboarding', 'slack', 'admin', 'enums', 'vacations', 'performanceReview'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    returnNull: false, // Fix for compatibility with Radix UI Slot component
  });

export default i18n;
